import { EPermissoes } from '@/enums/ePermissoes';
import utlTipoFornecimentoService from '@/services/utilidade/utl-tipo-fornecimento.service';

export default [
  {
    description: 'Cadastro de Bloco',
    path: 'produto',
    name: 'bloco',
    component: () => import('@/views/utilidade/produto/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroProduto],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusão de Bloco',
    path: 'produto/incluir',
    name: 'blocoinsert',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'bloco',
      utlTipoFornecimentoId: 301,
      campos: () => utlTipoFornecimentoService.getCamposProduto(301),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Inclusão de Bloco',
    path: 'produto/incluir/:id',
    name: 'blocoinsertcopy',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'bloco',
      utlTipoFornecimentoId: 301,
      campos: () => utlTipoFornecimentoService.getCamposProduto(301),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Edição de Bloco',
    path: 'produto/editar/:id',
    name: 'blocoupdate',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'bloco',
      utlTipoFornecimentoId: 301,
      campos: () => utlTipoFornecimentoService.getCamposProduto(301),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Fornecedor de Bloco',
    path: 'fornecedor-obra',
    name: 'fornecedorobra-bloco',
    component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Unidade Tipo de Bloco',
    path: 'unidade-tipo',
    name: 'unidadetipobloco',
    component: () => import('@/views/gestao/unidade-tipo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'bloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra],
      grupos: [],
      ambienteRouteName: 'ambientebloco',
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão Unidade Tipo de Bloco',
    path: 'unidade-tipo/incluir',
    name: 'unidadetipoblocoinsert',
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadetipobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Unidade Tipo de Bloco',
    path: 'unidade-tipo/editar/:id',
    name: 'unidadetipoblocoupdate',
    meta: {
      parentRouteName: 'unidadetipobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue')
  },
  {
    description: 'Local de Aplicação',
    path: 'ambiente/:gesUnidadeTipoId',
    name: 'ambientebloco',
    component: () => import('@/views/gestao/ambiente/Index.vue'),
    goesToMenu: false,
    meta: {
      tipoFornecimento: 'bloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Local de Aplicação',
    path: 'ambiente/incluir/:gesUnidadeTipoId',
    name: 'ambienteblocoinsert',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambientebloco',
      tipoFornecimento: 'bloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edição de Local de Aplicação',
    path: 'ambiente/editar/:gesUnidadeTipoId/:id',
    name: 'ambienteblocoupdate',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambientebloco',
      tipoFornecimento: 'bloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Unidade de Bloco',
    path: 'unidade',
    name: 'unidadebloco',
    component: () => import('@/views/gestao/unidade/Index.vue'),
    meta: {
      tipoFornecimento: 'bloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Unidade de Bloco',
    path: 'unidade/incluir',
    name: 'inclusaounidadebloco',
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadebloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Unidade de Bloco',
    path: 'unidade/editar/:id',
    name: 'unidadeblocoupdate',
    meta: {
      parentRouteName: 'unidadebloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue')
  },
  {
    description: 'Tipo Ensaio de Bloco',
    path: 'tipo-ensaio',
    name: 'tipoensaiobloco',
    component: () => import('@/views/utilidade/tipoensaio/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'global'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Tipo Ensaio de Bloco',
    path: 'tipo-ensaio/incluir',
    name: 'tipoensaioblocoinsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaiobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo Ensaio de Bloco',
    path: 'tipo-ensaio/editar/:id',
    name: 'tipoensaioblocoupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaiobloco',
      utlTipoFornecimentoId: 301,
      permissions: [EPermissoes.CadastroObra]
    }
  }
];
